import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import WhiteContainer from '../../../../components/Accessibility/WhiteContainer';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const TranscricaoListaEmptyState: React.FC = () => {
  const accessibility = useAccessibility();

  return (
    <WhiteContainer
      shadow
      className="consultar-transcricao-empty-state"
      style={accessibility.contrastBorderAccessibility}
    >
      <div className="consultar-transcricao-empty-state-content">
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="consultar-transcricao-empty-state-icon"
          aria-hidden
        />
        <div className="consultar-transcricao-empty-state-text">
          <Typography
            component="p"
            className="consultar-transcricao-empty-state-title"
            style={accessibility.textStyleAccessibility}
          >
            Nenhum resultado encontrado!
          </Typography>
          <Typography
            component="p"
            className="consultar-transcricao-empty-state-subtitle"
            style={accessibility.textStyleAccessibility}
          >
            Suas transcrições serão exibidas aqui
          </Typography>
        </div>
      </div>
    </WhiteContainer>
  );
};

export default TranscricaoListaEmptyState;
